import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  AreaChart, Area, RadialBarChart, RadialBar, Legend
} from 'recharts';
import PlatformFlow from './PlatformFlow';
import Panel from '../../components/design/Panel';

export default function DashboardSecurity({
  securityEvents, topAlerting, severityTimeline, activityFeed,
}) {
  const secData = [
    { name: 'Critical', value: securityEvents.critical || 0, fill: '#ef4444' },
    { name: 'High', value: securityEvents.high || 0, fill: '#f59e0b' },
    { name: 'Medium', value: securityEvents.medium || 0, fill: '#3b82f6' },
    { name: 'Low', value: securityEvents.low || 0, fill: '#10b981' },
  ].filter(d => d.value > 0);
  const totalSec = secData.reduce((s, d) => s + d.value, 0);

  return (
    <div>
      <div className="grid grid-2 section-gap">
        <Panel title="Security Events (24h)">
          {totalSec > 0 ? (
            <div className="chart-box sm">
              <ResponsiveContainer width="100%" height="100%">
                <RadialBarChart innerRadius="30%" outerRadius="90%" data={secData} startAngle={180} endAngle={0}>
                  <RadialBar dataKey="value" cornerRadius={4} label={{ position: 'insideStart', fill: '#fff', fontSize: 9 }} />
                  <Legend iconSize={8} wrapperStyle={{ fontSize: 10, color: 'var(--text-2)' }} />
                  <Tooltip />
                </RadialBarChart>
              </ResponsiveContainer>
            </div>
          ) : <div className="empty">No security events</div>}
        </Panel>
        <Panel title="Top Alerting Servers (7d)">
          {topAlerting.length > 0 ? (
            <div className="chart-box sm">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={topAlerting.slice(0, 8)} layout="vertical" margin={{ left: 40 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="var(--grid-line)" />
                  <XAxis type="number" tick={{ fontSize: 9 }} stroke="var(--text-3)" />
                  <YAxis type="category" dataKey="name" tick={{ fontSize: 9 }} stroke="var(--text-3)" width={80} />
                  <Tooltip />
                  <Bar dataKey="alert_count" fill="#ef4444" radius={[0, 4, 4, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          ) : <div className="empty">No alert data</div>}
        </Panel>
      </div>

      <div className="section-gap">
        <Panel title="Incidents by Severity (30d)">
          {severityTimeline.length > 0 ? (
            <div className="chart-box sm">
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={severityTimeline}>
                  <CartesianGrid strokeDasharray="3 3" stroke="var(--grid-line)" />
                  <XAxis dataKey="date" tick={{ fontSize: 8 }} stroke="var(--text-3)" tickFormatter={v => v?.slice(5)} />
                  <YAxis tick={{ fontSize: 8 }} stroke="var(--text-3)" />
                  <Tooltip />
                  <Area type="monotone" dataKey="critical" stackId="1" stroke="#ef4444" fill="#ef4444" fillOpacity={0.4} />
                  <Area type="monotone" dataKey="high" stackId="1" stroke="#f59e0b" fill="#f59e0b" fillOpacity={0.4} />
                  <Area type="monotone" dataKey="warning" stackId="1" stroke="#3b82f6" fill="#3b82f6" fillOpacity={0.4} />
                  <Area type="monotone" dataKey="info" stackId="1" stroke="#10b981" fill="#10b981" fillOpacity={0.4} />
                  <Legend iconSize={8} wrapperStyle={{ fontSize: 9, color: 'var(--text-2)' }} />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          ) : <div className="empty">No severity data</div>}
        </Panel>
      </div>

      <div className="section-gap">
        <PlatformFlow />
      </div>
    </div>
  );
}
